<template>
  <div class="w3-margin-left">
    <div class="w3-padding-small">  
      <h2 class="" >Edit Test</h2>
    </div>
    <span>testPackId is: </span>
    <span>{{testPackId}}</span>
    <br>
    <span>patientId is: </span>
    <span>{{patientId}}</span>
    <br>
    <!-- <span>oldTest is: </span>
    <span class="w3-tiny">{{oldTest}}</span> -->

    <div class="w3-card w3-padding">
      <p>
        <input type="date" class="w3-input" v-model="sampling_date">
        <label>ნიმუშის აღების ღარიღი</label>
      </p>
      
      <p>
        <input type="date" class="w3-input" v-model="test_date">
        <label >კვლევის შესრულების თარიღი</label>
      </p>

      <p>
        <input type="date" class="w3-input" v-model="sample_receive_date">
        <label >ნიმუშის მიღების თარიღი</label>
      </p>

      <p>
        <input type="text" class="w3-input" v-model="sample_type">
        <label >ნიმუშის ტიპი</label>
      </p>


      <p>
        <input type="text" class="w3-input" list="datalist_doctors" v-model="physician_name">
        <label >ექიმის სახელი</label>
        <datalist id="datalist_doctors">
          <option v-for="(value, key) in doctorNames" v-bind:key="'doctor#'+key" v-bind:value="value.physician_name"></option>
        </datalist>
      </p>
    </div>

    <edit-test v-bind:testDef="testDefs[testPackId]" v-bind:prefillData="{prefillData}" v-on:test-submited="saveData"/>

  </div>
</template>

<script>
import EditTestVue from "../components/EditTest.vue";
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';

var api_path = "/php_scripts/";
if (process.env.NODE_ENV === "development") {
  api_path = "http://localhost/php_scripts/";
}

export default {
  components: {
    "edit-test": EditTestVue
  },
  props:['oldTest', 'patientId', 'testPackId'],
  data: function(){
    let dat = {
      test_date: null,
      sampling_date: null,
      sample_type: null,
      physician_name: null,
      sample_receive_date: null,
      prefillData: {},
      doctorNames: {}
    }
    if(this.oldTest){
      console.log("old test detected")
      console.log(this.oldTest)
      dat.test_id = this.oldTest.test_id
      dat.test_date = this.oldTest.test_date
      dat.sampling_date = this.oldTest.sampling_date
      dat.sample_type = this.oldTest.sample_type
      dat.physician_name = this.oldTest.physician_name
      dat.sample_receive_date = this.oldTest.sample_receive_date
      for (var key in this.oldTest.test_res) {
      // skip loop if the property is from prototype
        if (!this.oldTest.test_res.hasOwnProperty(key)) continue;

        dat.prefillData[key] = this.oldTest.test_res[key].test_result
      }
      console.log(dat.prefillData);
    }
    return dat;
  },
  computed:{
    ...mapGetters({testDefs:"getTestDefs"})
  },
  methods:{
    ...mapActions({getDoctorNames: 'GET_DOCTOR_NAMES'}),
    saveData(payload){
      console.log(payload);

      //load data from test data 
      let test_data = {
        test_id : this.test_id,
        test_date: this.test_date,
        sampling_date: this.sampling_date,
        sample_type: this.sample_type,
        physician_name: this.physician_name,
        sample_receive_date: this.sample_receive_date,
      }

      let aggregated_values = payload.values

      axios({
          method: "POST",
          url: api_path + "insert_test_by_id_json.php",
          data: {
            test_pack_id: this.testPackId,
            patient_id: this.patientId,
            test_data: test_data,
            aggregated_values: aggregated_values
          }
      })
        .then(response => {
            console.log("response OK");
            console.log(response);
            alert("Save OK");
            this.$router.go(-1)
        })
        .catch(function(error) {
            console.log(error);
            // console.log(this);
            alert("Not Saved");
        });

    }
  },
  mounted(){
    this.getDoctorNames()
      .then((data)=>{this.doctorNames = data})
      .catch((error)=>{})
  }
};
</script>